import { ApiEndpointUrl } from "../../common";
export const categoryPoint = { list: ApiEndpointUrl + "descendant-categories?parent_id=1",
                                childList:ApiEndpointUrl + "descendant-categories?parent_id=" };
